import { useParams, Link } from 'react-router-dom';
import { useEffect, useState } from 'react';

export default function RenewSuccessPage() {
  const params = new URLSearchParams(window.location.search);
  const sessionId = params.get('session_id');
  const [status, setStatus] = useState<'checking' | 'success' | 'pending'>('checking');

  useEffect(() => {
    // The webhook processes async; show success after a brief delay
    // In production, we'd poll the checkout session status
    const timer = setTimeout(() => setStatus('success'), 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="renew-page">
      <div className="renew-container">
        {status === 'checking' && <h1>Processing your payment...</h1>}
        {status === 'success' && (
          <>
            <div className="success-icon">✅</div>
            <h1>Payment Successful!</h1>
            <p>Your MarineLink listing has been renewed. Your subscription is now active.</p>
            <p className="session-info">Session: {sessionId?.substring(0, 20)}...</p>
            <Link to="/" className="btn-back">← Back to MarineLink</Link>
          </>
        )}
      </div>
    </div>
  );
}
